<template>
  <div :class="$vuetify.breakpoint.xsOnly ? 'rel' : ''">
    <router-link
      :to="
      project.status == 'creating'
        ? {
            name: 'SalesProjectCreateContinue',
            params: { id: project.id },
            query: { step: '1' },
          }
        : {
            name:
              project.status == 'bidding' || project.status == 'pending'
                ? 'SalesProjectShow'
                : project.status == 'in_progress'
                ? 'ProjectsProjectShow'
                : project.status == 'done'
                ? 'ProjectsDoneShow'
                : project.status == 'canceled' || project.status == 'intro'
                ? 'SalesArchiveShow'
                : '',
            params: { id: project.id },
          }
    "
      class="project"
      :class="{ table: gridTable }"
    >
      <div class="project_head">
        <v-img
          class="avatar"
          v-if="project.images"
          :src="apiDomain + '/min/' + project.images"
          :height="$vuetify.breakpoint.xsOnly ? 50 : 98"
          :width="$vuetify.breakpoint.xsOnly ? 50 : 98"
          alt=""
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#277faf"></v-progress-circular>
            </v-row>
          </template>
        </v-img>

        <div v-else class="avatar noPhoto">
          <img :src="require('~/assets/svg/ImageNotFound.svg')" />
          <!-- <span class="f36 fw700 initials">{{ project.name.charAt(0) }}</span> -->
        </div>
        <ProjectStatus :status="project.status" />
      </div>
      <v-hover v-slot="{ hover }">
        <div class="box" :class="{ active: gridTable }">
          <!-- <div class="box_grid">
                    <span v-if="gridTable" class="box_number f12">{{
                        $clientProjectNumber({
                            project_id: project.id,
                            yaear: project.year,
                            segment_letter: segmentLetter,
                        })
                    }}</span>
                </div> -->
          <div class="box_title f14 fw500">
            <span v-if="project.internal_project_id != null">
              {{ project.internal_project_id + ' ' + project.name }}
            </span>
            <span v-else>
              {{ project.name }}
            </span>
          </div>
          <div v-if="hover && $vuetify.breakpoint.smAndUp" class="box_title_hint f14 fw500">
            <span v-if="project.internal_project_id != null">
              {{ project.internal_project_id + ' ' + project.name }}
            </span>
            <span v-else>
              {{ project.name }}
            </span>
          </div>
          <div class="box_date f14">
            {{ $formatDate(project.start_date) + ' - ' + $formatDate(project.end_date) }}
          </div>

          <template v-if="show || $vuetify.breakpoint.smAndUp">
            <p class="box_client f12">{{ project.work_client ? project.work_client.name : '-' }}</p>
            <span v-if="!gridTable" class="box_number f12">{{
                $clientProjectNumber({
                  project_id: project.id,
                  year: project.year,
                  segment_letter: project['business_segment'] ? project['business_segment'].name[0] : '',
                })
              }}</span>
          </template>
        </div>
      </v-hover>
      <div v-if="$vuetify.breakpoint.xsOnly" class="mr-9"/>
    </router-link>
    <v-btn
      @click.stop="show = !show"
      icon
      color="primary"
      v-if="$vuetify.breakpoint.xsOnly"
      absolute
      class="open_btn"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg" width="24" height="24"
        preserveAspectRatio="xMidYMid meet"
        viewBox="1 1 10 10"
        :class="show ? 'icon-rotate' : ''"
      >
        <path
          fill="currentColor"
          d="M7.854 5.854a.5.5 0 1 0-.708-.708L6 6.293L4.854 5.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l1.5-1.5ZM11 6A5 5 0 1 0 1 6a5 5 0 0 0 10 0ZM6 2a4 4 0 1 1 0 8a4 4 0 0 1 0-8Z"/>
      </svg>
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import project from 'components/icons/projects/project'
import ProjectStatus from 'components/project/ProjectStatus'
export default {
  name: 'ProjectCard',
  components: {
    ProjectStatus,
  },
  props: ['project'],
  data: () => ({
    show: false,
  }),
  computed: {
    ...mapGetters('workBusinessSegment', ['businessSegmentAll']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
    statusText() {
      return this.project.status == 'creating'
        ? this.localStorage.translations.pages.projects_status.status['predvaritelnyy'] || ''
        : this.project.status == 'intro'
        ? this.localStorage.translations.pages.projects_status.status['beginer'] || ''
        : this.project.status == 'bidding'
        ? this.localStorage.translations.pages.projects_status.status['tsenopredlozhenie'] || ''
        : this.project.status == 'canceled'
        ? this.localStorage.translations.pages.projects_status.status['ne-sostoyavshiysya'] || ''
        : this.project.status == 'pending'
        ? this.localStorage.translations.pages.projects_status.status['v-ozhidanii'] || ''
        : this.project.status == 'in_progress'
        ? this.localStorage.translations.pages.projects_status.status['v-rabote'] || ''
        : this.project.status == 'done'
        ? this.localStorage.translations.pages.projects_status.status['zavershen'] || ''
        : null
    },
    segmentLetter() {
      let result = null
      if (this.businessSegmentAll.length && this.project && this.project.business_segment_id) {
        result = this.businessSegmentAll
          .find((i) => i.id === this.project.business_segment_id)
          .name.substr(0, 1)
      }
      return result
    },
    gridTable() {
      return this.$route.query.grid === 'table'
    },
    pageSales() {
      return this.$route.name === 'Sales'
    },
  },
}
</script>

<style lang="scss" scoped>
svg {
  transition-duration: 0.3s;

  &.icon-rotate {
    transition-duration: 0.3s;
    transform: rotateZ(-180deg);
    transform-origin: center;
  }
}
.rel {
  position: relative;
}
.open_btn {
  top: calc(50% - 18px);
  right: 8px;
}
.project {
  background: #ffffff;
  border: 1px solid #bedbeb;
  border-radius: 4px;
  text-align: center;
  padding: 15px;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  transition: 0.3s;
  align-content: center;
  align-items: center;
  @media #{map-get($display-breakpoints, 'sm-only')} {
    border: none;
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    border: none;
    padding: 12px;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
  }

  &:hover {
    box-shadow: 0px 0px 16px rgba(67, 142, 184, 0.4);
  }
  &_head {
    display: grid;
    // grid-template-columns: max-content auto;
    width: 100%;
    align-items: center;
    justify-items: center;
    justify-content: center;
    gap: 15px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      width: auto;
      gap: 8px;
    }
    .avatar {
      height: 98px;
      width: 98px;
      border-radius: 50%;
      display: grid;
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        height: 62px;
        width: 62px;
      }
      img {
        border-radius: inherit;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.noPhoto {
        background-color: #f2f2f2;
        flex-direction: column;
        justify-content: center;
        justify-items: center;
        align-items: center;
        align-content: center;

        .initials {
          text-transform: uppercase;
          line-height: 1;
          color: #ffffff;
        }
        svg {
          margin-top: -20px;
          margin-bottom: -10px;
          width: 26px;
          height: 45px;
        }
      }
    }
  }

  .status {
    background: #888888;
    border-radius: 4px;
    padding: 4px 8px;
    line-height: 148%;
    color: #ffffff;
    width: max-content;
    height: max-content;
    justify-self: center;
    &.creating {
      background: #008deb;
    }
    &.bidding {
      background: #f2a127;
    }
    &.pending {
      background: #ffeb3b;
      color: #000;
    }
    &.in_progress {
      background: #26bc2c;
    }
  }
  .box {
    position: relative;
    justify-self: center;
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    // grid-template-rows: 1fr auto;
    // height: 100%;
    &_title {
      display: block;
      text-align: center;
      width: 100%;
      margin: 10px 0 4px;
      line-height: 21px;
      color: #16558f;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      @media #{map-get($display-breakpoints, 'xs-only')} {
        margin: 10px 0 4px;
        white-space: normal;
      }

      &_hint {
        @extend .box_title;
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 2px;
        min-width: 100%;
        width: auto;
        background-color: white;
        white-space: nowrap;
        overflow: visible;
      }
    }

    &_number {
      display: block;
      color: #b4b4b4;
    }
    &_project-id {
      color: #52525f;
      margin: 0 0 12px;
      word-break: break-word;
    }
    &_client {
      font-weight: normal;
      color: #52525f;
      margin-bottom: 10px;
    }
    &_date {
      margin-bottom: 10px;
    }
    &.active {
      justify-items: flex-start;
      .box_grid {
        display: grid;
        grid-template-columns: repeat(2, max-content);
        grid-column-gap: 8px;
        align-items: center;
      }
    }
  }

  &.table {
    grid-template-columns: max-content auto;
    grid-column-gap: 30px;
    justify-content: flex-start;
    .avatar {
      margin: 0;
    }
    .box_title {
      text-align: start;
    }
  }
}
</style>
